<template>
  <transition name="fade">
    <div class="Terms" v-if="visible">
      <img
        class="Terms-logo"
        ref="logo"
        src="@/assets/img/logo.svg"
        alt="Carta Blanca"
      />
      <div class="Terms-close" @click="$emit('close')" />
      <CookiesApi />
    </div>
  </transition>
</template>

<script>
import CookiesApi from "@/components/CookiesApi";

export default {
  props: {
    visible: {
      type: Boolean,
    },
  },
  components: {
    CookiesApi,
  },
};
</script>

<style lang="stylus" scoped>
@import 'Terms.styl';

</style>